import React, { useCallback, useMemo, useReducer } from 'react';

import sidebarConstants    from './sidebar.constants';
import SidebarContext      from './sidebar.context';
import sidebarReducer      from './sidebar.reducer';
import sidebarInitialState from './sidebar.state';

/**
 * @type {React.FC}
 */

const SidebarProvider = function({
  children,
  value = sidebarInitialState,
}) {
  const [state, dispatch] = useReducer(sidebarReducer, value);

  const hideSidebar = useCallback(() => {
    document.body.classList.remove('fixed');

    dispatch({ type: sidebarConstants.HIDE_SIDEBAR });
  }, [dispatch]);

  const showSidebar = useCallback((sidebar, title = '') => {
    document.body.classList.add('fixed');

    dispatch({
      type:    sidebarConstants.SHOW_SIDEBAR,
      sidebar: sidebar,
      title,
    });
  }, [dispatch]);

  const showGratitudeModal = useCallback(() => {
    dispatch({ type: sidebarConstants.SHOW_GRATITUDE_MODAL });

    if (typeof window.ym === 'function') {
      ym(47794993, 'reachGoal', 'consultationRequest');
    }
  }, [dispatch]);

  const hideGratitudeModal = useCallback(() => {
    dispatch({ type: sidebarConstants.HIDE_GRATITUDE_MODAL });
  }, [dispatch]);

  const context = useMemo(() => ({
    ...state,
    hideSidebar,
    hideGratitudeModal,
    showSidebar,
    showGratitudeModal,
  }), [state]);

  return (
    <SidebarContext.Provider value={context}>
      {children}
    </SidebarContext.Provider>
  );
};

export default SidebarProvider;